export default function Trapezoid() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="20" viewBox="0 0 60 20" fill="none" overflow="visible">
      {/* Fill */}
      <path
        d="M45.0557 0C48.0857 0 50.8557 1.71184 52.2109 4.42188L60 20H0L7.78906 4.42188C9.14427 1.71185 11.9143 0 14.9443 0H45.0557Z"
        fill="var(--color-card-deco-trapezoid-fill)"
      />
      {/* Stroke: top + sides only */}
      <path
        d="M0 20L7.78906 4.42188C9.14427 1.71185 11.9143 0 14.9443 0H45.0557C48.0857 0 50.8557 1.71184 52.2109 4.42188L60 20"
        stroke="var(--color-card-deco-trapezoid-stroke)"
        strokeWidth="1"
        fill="none"
      />
    </svg>
  );
}
